import { stringToSVG } from '../../../utilities';

const svg = `<svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.5 4.5L3.5 7.5L10.5 0.5" stroke="#082032"/>
</svg>
`;
export default stringToSVG(svg);